module.exports = __webpack_public_path__ + "static/media/edit.4363d951.svg";